import { memo } from 'react';

import { type AssetCustomFieldValue, type BoardCustomFieldValue } from '@air/api/types';
import { EditableDate, type EditableDateProps } from '@air/component-editable-date';

import { CUSTOM_FIELD_DATE } from '~/constants/testIDs';

export type CustomFieldDateInputProps = {
  field: BoardCustomFieldValue | AssetCustomFieldValue;
  onBlur?: () => void;
  onChange: (date: Date | null) => void;
  canEditCustomFields: boolean;
} & Omit<EditableDateProps, 'label' | 'name' | 'dateValue' | 'variant' | 'onEditingStateChange' | 'onChange'>;

export const CustomFieldDateInput = memo(
  ({ field, onBlur, onChange, canEditCustomFields, ...rest }: CustomFieldDateInputProps) => {
    return (
      <EditableDate
        {...rest}
        onChange={(date: Date | null) => {
          const dateValue = date?.toISOString();
          if (dateValue === field.dateValue) return;

          onChange(date);
        }}
        onEditingStateChange={(isEditing) => {
          if (!isEditing) {
            onBlur?.();
          }
        }}
        data-testid={`${CUSTOM_FIELD_DATE}-${field.name}`}
        size="large"
        name={field.id}
        dateValue={field.dateValue}
        placeholder={canEditCustomFields ? 'Add a date' : 'None'}
        readOnly={!canEditCustomFields}
        showCalendarIcon={false}
        buttonClassName="rounded-4 bg-transparent p-1.5 transition-colors border border-grey-5 hover:border-grey-7 hover:bg-grey-2 pl-2"
      />
    );
  },
);

CustomFieldDateInput.displayName = 'CustomFieldDateInput';
